import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./Report.scss";
import { _Api } from "../common/api/_call";
import { Reportmenupos } from "./Reportmenupos";
import SocialModal from "../../components/common/modules/SocialModal/SocialModal";
import { Daterangepos } from "../common/Daterangepos";
import { loading, Updateloading, error } from "../common/helpers/toastify";
import DailySaleReportTableHead from "./DailySaleReportTableHead";
import { useReportColumnFilters } from "./useReportColumnFilters";
import {
  getNextSortConfig,
  sortGiftCardReportRows,
} from "./giftCardReportTableConfig";
import { useReportStickyColumns } from "./useReportStickyColumns";
import { posgiftctadreport_head } from "../../components/common/Tablehead";
import TableModal from "../common/Modals/tableColumnPos";
import { useTranslation } from "react-i18next";
import { Pagination } from "../common/Pagination";
import { toFormatPrice } from "../common/helpers/function";
import * as FileSaver from "file-saver";
import { useSelector } from "react-redux";
import Select from "react-select";
import * as XLSX from "xlsx";
import { GiftCardSubTable } from "./Giftcardsubtable";
import GreenTick from "../../admin/common/icons/GreenTick";
import $ from "jquery";
const Giftcardreport = () => {
    const { t } = useTranslation();
    const [excuteTable, setexcuteTable] = useState(false);
    const [socialurl, setSocialurl] = useState();
    const [newcolumndata, setnewcolumndata] = useState(posgiftctadreport_head);
    const [datefilter, setDatefilter] = useState([]);
    const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
    const [filtername, setFiltername] = useState("");
    const [giftcarddata, setGificarddata] = useState([]);
    const [upercount, setUpercount] = useState();
    const [lowercount, setLowercount] = useState();
    const [shareloader, setShareloader] = useState(false);
    const [pdfLoadingIds, setPdfLoadingIds] = useState(new Set());
    const [limit, setLimit] = useState(100);
    const [sortConfig, setSortConfig] = useState({
        columnIndex: 1,
        direction: "desc",
    });
    const fileType =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const [printparmission, setPrintparmission] = useState(0);
    const [editparmission, setEditparmission] = useState(0);
    const [showSubtasks, setShowSubtasks] = useState(false);
    const [activeSubtask, setActiveSubtask] = useState("Collapse all");
    const subtaskRef = useRef(null);
    const reportTableContainerRef = useRef(null);

    const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);

    const activeTableColumns = newcolumndata?.length
        ? newcolumndata
        : posgiftctadreport_head;

    const columnFilters = useReportColumnFilters(giftcarddata, { customer: "customer_name" })
    const sortedGiftcarddata = useMemo(
        () => sortGiftCardReportRows(columnFilters.rows, sortConfig),
        [columnFilters.rows, sortConfig]
    );

    const handleGiftCardReportSort = (columnIndex, direction) => {
        setSortConfig((current) => getNextSortConfig(current, columnIndex, direction));
    };

    useReportStickyColumns(reportTableContainerRef, [
        sortedGiftcarddata,
        activeTableColumns,
        excuteTable,
    ]);

    useEffect(() => {
        if (parmissiondatashow?.pos_reports?.View)
            setPrintparmission(parmissiondatashow?.pos_reports?.Print)
        setEditparmission(parmissiondatashow?.pos_reports?.Edit);
    }, [parmissiondatashow]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (subtaskRef.current && !subtaskRef.current.contains(event.target)) {
                setShowSubtasks(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const callcolumns = async () => {
        try {
            const postdata = {
                name: "report_giftcardreport_tbl",
            };
            let columnhead = await _Api(
                postdata,
                `api/v1/Inventory/common/getColumnHeads`
            );
            if (columnhead.code === 200) {
                setnewcolumndata(columnhead?.data?.data);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    useEffect(() => {
        callcolumns();

    }, []);
    const collapseAll = () => {
        document.querySelectorAll('.table_btn_expand_col.rotate-90').forEach(e => e.classList.remove('rotate-90'));
        let alllist_data = [...giftcarddata];
        alllist_data = alllist_data.map(item => ({ ...item, subTabledata: null }));
        setGificarddata(alllist_data);
    };
    const expandAll = async () => {
        let alllist_data = [...giftcarddata];
        const order_ids = alllist_data.map(item => item.order_id);
        const gift_card_ids = alllist_data.map(item => item.gift_card_id);
        if(!gift_card_ids?.length||!order_ids?.length){
               error("No creditnotes in the list")
               return;
            }
            let GetloadingID = loading();
        try {
            const response = await _Api(
                { order_ids, gift_card_ids },
                `api/v1/POS/report/giftCardTransactionBatchDetails`
            );
            if (response?.code === 200) {
                for (let i = 0; i < alllist_data.length; i++) {
                    const result = alllist_data[i];
                    const rowData = response.data[result.gift_card_id];
                    if (rowData) {
                        const e = document.querySelector("#table-btn_" + result.gift_card_id);
                        if (e) e.classList.add("rotate-90");
                        alllist_data[i] = {
                            ...alllist_data[i],
                            subTabledata: GiftCardSubTable({ code: 200, data: rowData }, result.gift_card_id, t)
                        };
                    }
                }
                setGificarddata([...alllist_data]);
                alllist_data.forEach((result) => {
                    const row = document.querySelector('#common-main-table-wrap-' + result.gift_card_id);
                    const checkRowSub = setInterval(() => {
                        const rowSub = document.querySelector('#common-sub-table-wrap-' + result.gift_card_id);
                        if (rowSub) { $(row).after(rowSub); clearInterval(checkRowSub); }
                    }, 100);
                });
                Updateloading(t, GetloadingID, t("Details Fetched Successfully"));
            }
            else{
              Updateloading(t, GetloadingID, t("No Data found"),'error');
            }
        } catch (err) { console.log(err, "err");
          Updateloading(t, GetloadingID, err, 'error');
         }
    };
     const setSubTablecustom = async (id,order_id) => {
        var e = document.querySelector("#table-btn_" + id);
        var row = document.querySelector('#common-main-table-wrap-' + id);
        var classList_ = e.classList;
        if (classList_.contains("rotate-90")) {
          classList_.remove("rotate-90");
          let alllist_data = [...giftcarddata];
          alllist_data.filter(item => item.gift_card_id === id).forEach((result) => {
            result.subTabledata = null
          })
          setGificarddata(alllist_data);
        } else {
          classList_.add("rotate-90");
          let alllist_data = [...giftcarddata];
          const postdata = {
            "order_id": order_id,
            "gift_card_id":id
          };
          let prioritydata = await _Api(postdata, `api/v1/POS/report/giftCardTransactionDetails`);
          var html_ = GiftCardSubTable(prioritydata, id, t);
          alllist_data.filter(item => item.gift_card_id === id).forEach((result) => {
            result.subTabledata = html_
          })
          setGificarddata(alllist_data);
          var checkRowSub = setInterval(function () {
            var rowSub = document.querySelector('#common-sub-table-wrap-' + id);
            if (rowSub) {
              $(row).after(rowSub);
              clearInterval(checkRowSub);
            }
          }, 100);
        }
      }
    const getsharegificardreport = async () => {
        setShareloader(true);
        try {
            const postdata = {
                "search": filtername,
                "start_date": datefilter ? datefilter[0] : "",
                "end_date": datefilter ? datefilter[1] : ""
            };
            let res = await _Api(postdata, `api/v1/POS/reports/print/giftCard`);

            if (res.code === 200) {
                setSocialurl(res?.link);
                setShareloader(false);
            }
        }
        catch (err) {
            console.log(err, 'err');
        }

    }
    const getprintgiftcardrreport = async () => {
        let GetloadingID = loading();
        try {
            const postdata = {
                "search": filtername,
                "start_date": datefilter ? datefilter[0] : "",
                "end_date": datefilter ? datefilter[1] : ""
            };
            let res = await _Api(postdata, `api/v1/POS/reports/print/giftCard`);

            if (res.code === 200) {
                setTimeout(() => {
                    const exportLinkElement = document.createElement('a');
                    exportLinkElement.hidden = true;
                    exportLinkElement.download = res?.name ? res?.name : "report.pdf";
                    exportLinkElement.href = res?.link;
                    exportLinkElement.text = "downloading...";
                    exportLinkElement.setAttribute('target', '_blank');
                    document.body.appendChild(exportLinkElement);
                    exportLinkElement.click();
                    exportLinkElement.remove();
                    Updateloading(t, GetloadingID, t("download successfully"));

                }, 50)
                setSocialurl(res?.link);
            } else {
                Updateloading(t, GetloadingID, res?.message ? (res?.message) : (res?.errors), 'error');
            }
        }
        catch (err) {
            console.log(err, 'err');
            Updateloading(t, GetloadingID, err, t('error'));
        }

    }

    const filterbyname = (search) => {
        getgetgiftcardreport(currentPage, limit, search);
        setstate({ ...state, currentPage: 1 });
    };
    const getlimit = (limit) => {
        setLimit(limit);
        getgetgiftcardreport(1, limit);
        setstate({ ...state, currentPage: 1 });

    };
    const [state, setstate] = useState({
        totalPages: 20,
        currentPage: 1,
    });

    const { totalPages, currentPage } = state;
    const handlePaginations = (current) => {
        setstate({ ...state, currentPage: current });
        getgetgiftcardreport(current, "");

    };
    const getgetgiftcardreport = async (current, firstlimit, search) => {
        setexcuteTable(false);
        try {
            const postdata = {
                search: search ? search : "",
                start_date: datefilter ? datefilter[0] : "",
                end_date: datefilter ? datefilter[1] : "",
                limit: firstlimit ? firstlimit : limit,
                skip: current ? (current - 1) * limit : 0,
            };
            let listdata = await _Api(postdata, `api/v1/POS/report/giftCard`);
            if (listdata.code === 200) {
                setexcuteTable(true);
                setGificarddata(listdata?.data);
                setstate({
                    ...state,
                    totalPages: Math.ceil(listdata?.count / postdata.limit),
                    currentPage: current ? current : 1,
                });
                setUpercount(listdata?.uppercount);
                setLowercount(listdata?.lowercount);
            } else {
                setGificarddata([]);
            }
        } catch (err) {
            console.log(err, "err");
        }
    };
    useEffect(() => {
        if (datefilter[0] && datefilter[1]) {
            getgetgiftcardreport();
        }
        // eslint-disable-next-line
    }, [newcolumndata, datefilter]);
    const downloadexclsheet = async () => {
        let header_values = [];
        let bodyarray = [];
        posgiftctadreport_head.map(async (r, k) => {
            header_values.push(r?.lable)
        })
        if (giftcarddata.length) {
            giftcarddata.forEach((result, key) => {
                bodyarray.push([key + 1, result?.voucher_no, result?.gc_no, result?.gc_name, result?.purchaseDate, result?.expire_date, result?.amount
                    , result?.current_amount, result?.remark, result?.location_name, result?.customer_name])
            })
        }

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(bodyarray, { origin: 'A2', skipHeader: true });
        XLSX.utils.sheet_add_aoa(ws, [header_values], { origin: 'A1' });
        XLSX.utils.book_append_sheet(wb, ws, 'Records');
        const fileContent = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([fileContent], { type: fileType });
        FileSaver.saveAs(data, "giftcard_report");

    }
    const selectOptions = [
        { label: 100, value: 100 },
        { label: 200, value: 200 },
        { label: 300, value: 300 }
    ]
    return (
      <>
        <div className="main-body">
          <div className="main-body-row">
            <div className="main-body-row-left-col p-0 w-100">
              <div className="catalog-area bg-white page-menu-block Dailysalereport">
                <div className="Dailysalereport-header">
                  <div className="Dailysalereport-header-left">
                    <h3 className="common-navigation-header-left-heading Dailysalereport-head">
                      {" "}
                      <Link
                        to=""
                        className="gray-mid text-decoration-none Dailysalereport-head-report"
                      >
                        {t("REPORT")}
                      </Link>{" "}
                      <img
                        className="Dailysalereport-head-arrow mx-3"
                        src={base_assets + "images/pos/report/arrow-right.png"}
                        alt=""
                      />
                      <span className="Dailysalereport-head-pagename">
                        {t("Gift Card Report")}
                      </span>{" "}
                    </h3>
                  </div>
                  <div className="Dailysalereport-header-reportdetail">
                    <div className="Dailysalereport-header-reportdetail-box">
                      <div className="Dailysalereport-header-reportdetail-box-inner">
                        <img
                          className="Dailysalereport-header-reportdetail-box-inner-img"
                          src={base_assets + "images/pos/report/stock-img.png"}
                          alt=""
                        ></img>
                      </div>
                      <div className="Dailysalereport-header-reportdetail-box-text">
                        <span className="Dailysalereport-header-reportdetail-box-text-inner">
                          {t("Total Qty")}
                        </span>
                        <span className="Dailysalereport-header-reportdetail-box-text-data lightblue">
                          {upercount?.totalQty ? upercount?.totalQty : ""}
                        </span>
                      </div>
                    </div>
                    <div className="Dailysalereport-header-reportdetail-box">
                      <div className="Dailysalereport-header-reportdetail-box-inner">
                        <img
                          className="Dailysalereport-header-reportdetail-box-inner-img"
                          src={base_assets + "images/pos/report/value-img.png"}
                          alt=""
                        ></img>
                      </div>
                      <div className="Dailysalereport-header-reportdetail-box-text">
                        <span className="Dailysalereport-header-reportdetail-box-text-inner">
                          {t("Total Value")}
                        </span>
                        <span className="Dailysalereport-header-reportdetail-box-text-data maingreen">
                          {toFormatPrice(upercount?.amount, {
                            addSymbol: true,
                          })}
                        </span>
                      </div>
                    </div>
                    <div className="Dailysalereport-header-reportdetail-box">
                      <div className="Dailysalereport-header-reportdetail-box-inner">
                        <img
                          className="Dailysalereport-header-reportdetail-box-inner-img"
                          src={
                            base_assets + "images/pos/report/customer-img.png"
                          }
                          alt=""
                        ></img>
                      </div>
                      <div className="Dailysalereport-header-reportdetail-box-text">
                        <span className="Dailysalereport-header-reportdetail-box-text-inner">
                          {t("Total Customer")}
                        </span>
                        <span className="Dailysalereport-header-reportdetail-box-text-data lightgray">
                          {upercount?.customer ? upercount?.customer : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="Dailysalereport-content-area">
                  <div className="Dailysalereport-content-area-header">
                    <div className="Dailysalereport-content-area-header-inner">
                      <Reportmenupos Reportname={"Gift Card Report"} />
                      <div className="">
                        <Select
                          className="limit-select short mx-3"
                          options={selectOptions}
                          value={{ label: limit, value: limit }}
                          onChange={(e) => {
                            setLimit(e.value);
                            getlimit(e.value);
                          }}
                        />
                      </div>
                      <div className="date">
                        {" "}
                        <Daterangepos setDatefilter={setDatefilter} />
                      </div>
                      <div className='position-relative' ref={subtaskRef}>
                        <div
                          className={`calendarlist-headbar-left-subtasks ${activeSubtask === 'Expand all' ? 'active' : ''}`}
                          onClick={() => setShowSubtasks(!showSubtasks)}
                          style={{border:"none",background:"none"}}
                        >
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16 13C17.1046 13 18 12.1046 18 11C18 9.89543 17.1046 9 16 9C14.8954 9 14 9.89543 14 11C14 12.1046 14.8954 13 16 13Z" stroke={activeSubtask === 'Expand all' ? '#52CBC4' : "#A0A0A0"} />
                            <path d="M16 21C17.1046 21 18 20.1046 18 19C18 17.8954 17.1046 17 16 17C14.8954 17 14 17.8954 14 19C14 20.1046 14.8954 21 16 21Z" stroke={activeSubtask === 'Expand all' ? '#52CBC4' : "#A0A0A0"} />
                            <path d="M5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C6.10457 7 7 6.10457 7 5C7 3.89543 6.10457 3 5 3Z" stroke={activeSubtask === 'Expand all' ? '#52CBC4' : "#A0A0A0"} />
                            <path d="M5 8V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14" stroke={activeSubtask === 'Expand all' ? '#52CBC4' : "#A0A0A0"} />
                            <path d="M5 7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H14" stroke={activeSubtask === 'Expand all' ? '#52CBC4' : "#A0A0A0"} />
                          </svg>
                          <span>{t("Subtasks")}</span>
                        </div>
                        {showSubtasks &&
                          <div className='calendarlist-headbar-left-subtaskdropdown'>
                            <div className='calendarlist-headbar-left-subtaskdropdown-inner'>
                              <div className='calendarlist-headbar-left-subtaskdropdown-inner-title'>{t("Show Subtasks")}</div>
                              <div className='calendarlist-headbar-left-subtaskdropdown-inner-list'>
                                <div
                                  className='calendarlist-headbar-left-subtaskdropdown-inner-list-item'
                                  onClick={() => { setActiveSubtask('Collapse all'); setShowSubtasks(false); collapseAll(); }}
                                >
                                  <div className='heading'>
                                    {t("Collapse all")}
                                    <span className='default'>{t("(default)")}</span>
                                  </div>
                                  {activeSubtask === 'Collapse all' && <div><GreenTick /></div>}
                                </div>
                                <div
                                  className='calendarlist-headbar-left-subtaskdropdown-inner-list-item'
                                  onClick={() => { setActiveSubtask('Expand all'); setShowSubtasks(false); expandAll(); }}
                                >
                                  <div>{t("Expand all")}</div>
                                  {activeSubtask === 'Expand all' && <div><GreenTick /></div>}
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <div className="catalog-area-header-area-control-right">
                      <div className="com-search-area">
                        <input
                          type="text"
                          value={filtername}
                          placeholder={t(
                            "Search  by Ref number, voucher type, ..."
                          )}
                          onKeyPress={(e) =>
                            e.key === "Enter" && filterbyname(e.target.value)
                          }
                          onChange={(e) => setFiltername(e.target.value)}
                        />
                        {filtername ? (
                          <img
                            className="com-search-area-clear"
                            src={base_assets + "images/icons/False.png"}
                            onClick={(e) => {
                              setFiltername("");
                              filterbyname("");
                            }}
                            alt=""
                          />
                        ) : (
                          ""
                        )}
                        <img
                          onClick={() => filterbyname(filtername)}
                          className="com-search-area-img"
                          src={
                            base_assets +
                            "images/pos/icons/magnifying-glass.png"
                          }
                          alt=""
                        />
                      </div>
                      <div className=" dropdown Dailysalereport-content-area-header-leftdropdown">
                        <button
                          className="btn-style"
                          type="button"
                          id="dropdownMenuButton1"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          <img
                            src={
                              base_assets + "images/icons/ellipsis-circular.png"
                            }
                            alt=""
                          />
                        </button>
                        <ul
                          className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu"
                          aria-labelledby="dropdownMenuButton1"
                        >
                          <li className={printparmission ? "" : "d-none"}>
                            <Link
                              className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                              to="#"
                              onClick={(e) => {
                                getprintgiftcardrreport(e.target.value);
                              }}
                            >
                              <div className="dropdown-menu-img">
                                <img
                                  src={
                                    base_assets +
                                    "images/pos/report/print-icon.png"
                                  }
                                  alt=""
                                />
                              </div>
                              {t("Print")}
                            </Link>
                          </li>
                          <li
                            onClick={(e) => {
                              downloadexclsheet(e.target.value);
                            }}
                          >
                            <Link
                              className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                              to="#"
                            >
                              <div className="dropdown-menu-img">
                                <img
                                  src={
                                    base_assets +
                                    "images/pos/report/export-icon.png"
                                  }
                                  alt=""
                                />
                              </div>
                              {t("Export")}
                            </Link>
                          </li>
                          <li
                            data-bs-toggle="modal"
                            data-bs-target="#socialModal"
                            className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                            onClick={() => getsharegificardreport()}
                          >
                            <div className="dropdown-menu-img">
                              <img
                                src={
                                  base_assets +
                                  "images/pos/report/share-icon.png"
                                }
                                alt=""
                              />
                            </div>
                            {t("Share")}
                          </li>
                          <li
                            data-bs-toggle="modal"
                            data-bs-target="#columnModal"
                          >
                            <Link
                              className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                              to="#"
                            >
                              <div className="dropdown-menu-img">
                                <img
                                  src={
                                    base_assets + "images/icons/column-icon.png"
                                  }
                                  alt=""
                                />
                              </div>
                              {t("Column")}
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    className="Dailysalereport-content-area-main"
                    ref={reportTableContainerRef}
                  >
                    <div
                      className="main-body-main-table-wrap Dailysalereport-table position-relative"
                      id="table-scroll"
                    >
                      <table
                        id="giftcard_report"
                        className="common-table first-row-gray w-100 Dailysalereport-table-main daily-sale-report-table gift-card-report-table"
                      >
                        <DailySaleReportTableHead
                          tablehead={activeTableColumns}
                          sortConfig={sortConfig}
                          onSort={handleGiftCardReportSort}
                          columnFilters={columnFilters}
                        />
                        {/* <tbody>
                                            <>
                                                {giftcarddata ? giftcarddata.map((result, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td>{key + 1}</td>

                                                            <td className="link-color">{result?.voucher_no ? result?.voucher_no : ""}</td>
                                                            <td className="link-color"> <Link
                                                                to={editparmission ? "/app/pos/giftCard" : ""}
                                                                className="text-decoration-none"
                                                                state={{
                                                                    order_id: result?.order_id,
                                                                    order_edit: true,
                                                                    order_type: result?.order_type
                                                                }}
                                                            >
                                                                {result?.gc_no ? result?.gc_no : ""}
                                                            </Link></td>
                                                            <td>{result?.gc_name ? result?.gc_name : ""}</td>
                                                            <td>{result?.purchaseDate ? result?.purchaseDate : ""}</td>
                                                            <td>{result?.last_used_date ? result?.last_used_date :""}</td>
                                                            <td>{toFormatPrice(result?.amount, { addSymbol: true })}</td>
                                                            <td>{toFormatPrice(result?.total_redeemed_amount, { addSymbol: true })}</td>
                                                            <td>{toFormatPrice(result?.current_balance, { addSymbol: true })}</td>
                                                            <td>{result?.remark ? result?.remark : ""}</td>
                                                            <td>{result?.location_name ? result?.location_name : ""}</td>
                                                            <td>{result?.customer_name ? result?.customer_name : ""}</td>
                                                            <td>
                                                                {result?.printURL === "" ? "-"
                                                                    : <div onClick={() => {
                                                                        if (result?.printURL) {
                                                                            window.open(result?.printURL, '_blank', 'noreferrer')
                                                                        }
                                                                    }}><img
                                                                            className="pdf-image cursor-pointer"
                                                                            src={base_assets + "images/icons/pdf-icon.png"}
                                                                            alt=""
                                                                        /></div>
                                                                }
                                                            </td>
                                                        </tr>
                                                    )
                                                }) : ""}
                                            </>
                                        </tbody> */}
                        <tbody>
                          {giftcarddata
                            ? sortedGiftcarddata.map((result, key) => {
                                return (
                                  <React.Fragment key={key}>
                                    <tr id={`common-main-table-wrap-${result?.gift_card_id}`}>
                                      <td>{key + 1}</td>
                                      <td className="link-color">
                                        {result?.voucher_no || ""}
                                      </td>
                                      <td className='sku-col table_btn_expand_col'
                                      id={"table-btn_" + result?.gift_card_id}
                                      >
                                         <img
                                        className="sku-col-arrow cursor-pointer"
                                        src={
                                          base_assets +
                                          "/images/icons/right_green_button.png"
                                        }
                                        alt=""
                                        onClick={() => setSubTablecustom(result?.gift_card_id,result?.order_id)}
                                      />
                                        <Link
                                          to={
                                            editparmission
                                              ? "/app/pos/giftCard"
                                              : ""
                                          }
                                          className="text-decoration-none link-color"
                                          state={{
                                            order_id: result?.order_id,
                                            order_edit: true,
                                            order_type: result?.order_type,
                                          }}
                                        >
                                          {result?.gc_no || ""}
                                        </Link>
                                      </td>
                                      {/* <td className='sku-col table_btn_expand_col'
                                      onClick={() => setSubTablecustom(result?.id)}
                                      id={"table-btn_" + result?.id}>  <img
                                        className="sku-col-arrow cursor-pointer"
                                        src={
                                          base_assets +
                                          "/images/icons/right_green_button.png"
                                        }
                                        alt=""
                                      />
                                      {result?.order_no ? result?.order_no : ''}</td> */}
                                      <td>{result?.gc_name || ""}</td>
                                      <td>{result?.purchaseDate || ""}</td>
                                      <td>{result?.last_used_date || ""}</td>
                                      <td>
                                        {toFormatPrice(result?.amount, {
                                          addSymbol: true,
                                        })}
                                      </td>
                                      <td className="yellowcolor">
                                        {toFormatPrice(
                                          result?.total_redeemed_amount,
                                          { addSymbol: true }
                                        )}
                                      </td>
                                      <td className="lightgray">
                                        {toFormatPrice(
                                          result?.current_balance,
                                          { addSymbol: true }
                                        )}
                                      </td>
                                      <td>{result?.remark || ""}</td>
                                      <td>{result?.location_name || ""}</td>
                                      <td>{result?.customer_name || ""}</td>
                                      <td>
                                        {result?.printURL === "" ? (
                                          "-"
                                        ) : (
                                          <div
                                            style={pdfLoadingIds.has(result?.order_id) ? { pointerEvents: 'none', opacity: 0.5 } : {}}
                                            onClick={async () => {
                                              if (result?.printURL) {
                                                window.open(result?.printURL, "_blank", "noreferrer");
                                              } else {
                                                if (pdfLoadingIds.has(result?.order_id)) return;
                                                setPdfLoadingIds(prev => new Set(prev).add(result?.order_id));
                                                let getloading = loading();
                                                try {
                                                  const postdata = {
                                                    order_id: result?.order_id,
                                                    order_type: result?.order_type,
                                                    shipping_info: result?.customerInfo,
                                                  };
                                                  let res = await _Api(postdata, `api/v1/POS/customOrder/getOrderPdf`);
                                                  if (res?.code === 200) {
                                                    Updateloading(t, getloading, res?.message, "success");
                                                    window.open(res?.data?.url, "_blank", "noreferrer");
                                                  } else {
                                                    Updateloading(t, getloading, res?.message, "error");
                                                  }
                                                } catch (err) {
                                                  Updateloading(t, getloading, "Something went wrong", "error");
                                                } finally {
                                                  setPdfLoadingIds(prev => { const s = new Set(prev); s.delete(result?.order_id); return s; });
                                                }
                                              }
                                            }}
                                          >
                                            <img
                                              className="pdf-image cursor-pointer"
                                              src={base_assets + "images/icons/pdf-icon.png"}
                                              alt=""
                                            />
                                          </div>
                                        )}
                                      </td>
                                    </tr>
                                    {
                                    excuteTable ? (
                                      <>
                                        {typeof result.subTabledata == "undefined" ? (result.subTabledata = "") : result.subTabledata}
                                      </>
                                    ) : null
                                  }
                                  </React.Fragment>
                                );
                              })
                            : null}
                        </tbody>

                        <tfoot>
                          <tr>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td>
                              {toFormatPrice(lowercount?.amount, {
                                addSymbol: true,
                              })}
                            </td>
                            <td>
                              {toFormatPrice(lowercount?.current_amount, {
                                addSymbol: true,
                              })}
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  {giftcarddata.length > 0 ? (
                    <Pagination
                      total={totalPages}
                      current={currentPage}
                      pagination={(crPage) => handlePaginations(crPage)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
          <SocialModal shareUrl={socialurl} shareloader={shareloader} />
          <TableModal
            tablehead={posgiftctadreport_head}
            tblName={"report_giftcardreport_tbl"}
            setnewcolumndata={setnewcolumndata}
          />
        </div>
      </>
    );
}
export default Giftcardreport;
















